/* @flow */
import React from 'react';

import BoxBody from 'components/BoxBody.jsx';
import BoxHeader from 'components/BoxHeader.jsx';
import Button from 'components/Button.jsx';
import ClipboardTrigger from 'components/ClipboardTrigger.jsx';
import Container from 'components/Container.jsx';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import Input from 'components/Input.jsx';
import Label from 'components/Label.jsx';
import TabPanel from 'components/TabPanel.jsx';
import ToastActions from 'actions/ToastActions';
import getPrettyUrl from 'utils/getPrettyUrl';

import './styles/InviteShareLinkTab.scss';

class InviteShareLinkTab extends React.Component {
  props: {
    group: Group,
    title: mixed,
  }

  getEmailBody(): string {
    const { group } = this.props;
    return encodeURIComponent(
      'I’m using Remind to send important updates, assignments, and information for ' +
      `${group.getName()}. ` +
      'Please click on the link below to join our class. (For reference, our class code is ' +
      `@${group.getCode()}.)\n\r${group.getJoinUrl()}\n\r` +
      `Thanks for joining!\n\r${CurrentUser.getUser().getSignature()}\n\r` +
      'P.S. Remind is a free, safe, and easy way for me to reach you with important information. ' +
      'You can choose to receive notifications by text, email, or the app. Having trouble? ' +
      'Go here: https://help.remind.com/hc/en-us/articles/203541849');
  }

  getEmailSubject(): string {
    return encodeURIComponent(
      `Accept request to join ${this.props.group.getName()} with ` +
      `${CurrentUser.getUser().getSignature()}`);
  }

  showCopyToast(): void {
    ToastActions.showSuccessToast(
      'URL has been copied to your clipboard'
    );
  }

  renderContent() {
    return (
      <BoxBody>
        <Container size="xsmall">
          {this.renderImage()}
          {this.renderCopyLinkForm()}
          {this.renderEmailButton()}
        </Container>
      </BoxBody>
    );
  }

  renderCopyLinkForm() {
    const { group } = this.props;
    const referralUrl = group.getJoinUrl();
    const referralUrlPretty = getPrettyUrl(referralUrl);

    return (
      <div className="InviteShareLinkTab-form">
        <div className="InviteShareLinkTab-form-input">
          <Label text="URL" hidden />
          <Input value={referralUrlPretty} readOnly />
        </div>
        <ClipboardTrigger text={referralUrl} onCopy={this.showCopyToast}>
          <Button level="secondary" size="small">
            Copy link
          </Button>
        </ClipboardTrigger>
      </div>
    );
  }

  renderEmailButton() {
    return (
      <Button
        href={
          `mailto:?subject=${this.getEmailSubject()}&body=${this.getEmailBody()}`
        }
        target="_blank"
        full
        size="small"
        className="InviteShareLinkTab-emailBtn"
        eventElementName="email-link-button">
        <Glyph name="email" size="medium" />
        Email link
      </Button>
    );
  }

  renderHeader() {
    return (
      <BoxHeader
        title="Share this link any way you like!"
        subtext={'This link includes your class code, ' +
          'so anyone who has it can join your class instantly.'}
      />
    );
  }

  renderImage() {
    return (
      <div className="InviteShareLinkTab-img">
        <GroupAvatar group={this.props.group} className="InviteShareLinkTab-img-avatar" />
      </div>
    );
  }

  render() {
    return (
      <TabPanel
        key="webPanel"
        selectedBorderColor="flame"
        className="InviteShareLinkTab"
        eventElementName="tab-website-link"
        title={this.props.title}>
        {this.renderHeader()}
        {this.renderContent()}
      </TabPanel>
    );
  }
}

export default InviteShareLinkTab;



// WEBPACK FOOTER //
// ./src/groups/components/InviteShareLinkTab.jsx